export enum Themes {
	Light = 'light',
	Dark = 'dark',
}
